import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
	getProfileRequest: null,
	getProfileSuccess: ['profile'],
	updateProfileRequest: ['profile'],
	updateProfileSuccess: ['profile'],
	updatePasswordRequest: ['passwords'],
	updateSlugRequest: ['slug', 'password'],
	getTeamRequest: null,
	getTeamSuccess: ['team'],
	getAchievementsRequest: null,
	getAchievementsSuccess: ['achievements'],
	updateTeamMemberRequest: ['member'],
	updateTeamMemberSuccess: ['member'],
	removeTeamMemberRequest: ['member'],
	removeTeamMemberSuccess: ['member'],
	getInvitesRequest: null,
	getInvitesSuccess: ['invites'],
	createInvitesRequest: ['invites'],
	removeInviteRequest: ['invite'],
	removeInviteSuccess: ['invite'],
	reinviteRequest: ['invite'],
	updateThemeRequest: ['settings'],
	updateReportSettingsRequest: ['settings'],
	updateUserImageRequest: ['image'],
	updateUserImageSuccess: ['profile'],
	updateTeamNameRequest: ['teamName'],
	updateTeamImageRequest: ['image'],
	updateTeamImageSuccess: null,
	updateTeamLogoRequest: ['image'],
	updateTeamLogoSuccess: null,
	updateTeamLogoNegativeRequest: ['image'],
	updateTeamLogoNegativeSuccess: null,
	updateTeamFaviconRequest: ['image'],
	updateTeamFaviconSuccess: null,
	updateSchemeRequest: ['scheme'],
	setLoadingState: ['s'],
})

export const settingsTypes = Types
export default Creators
